import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Row, notification, Modal } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent, reactive } from "vue";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createButtonEdit, createButton, createButtonView } from "../../../../utils/button";
import { modalStyleIFrame } from "../../../../utils/constant";
import { checkAttribute, initUseForm, onClickEdit, onClickView, watchRulesChildren, copyForm } from "../../../../utils/form";
import { openModal as openModalOtp } from "../../../../components/verify-otp/verify-otp.logic";
import { openModalForm as openModalNotApprove } from "../modal/not-approve-request.logic";
import { createLoading } from "../../../../utils/loading";
import { flatWhereGroup } from "../../../../utils/search";

import {
    createAppPageHeaderTop,
    createManageExportCsv,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView,
} from "../../../../utils/page";
import { validateError, required, requiredWhen, thPid, email, thPidFirstCharacter } from "../../../../utils/validate";
import { createConditionAction, createConditionForm } from "./user-request-register.condition";
import { createColumns, createField, callUserRequestType } from "./user-request-register.section";
import {
    nextPageChecklinkIdCardPersonType1,
    nextPageChecklinkIdCardPersonType2,
} from "../../../../views/account/register-fisherman/register-fisherman.logic";

import { callAddressType, createForm as createFormAddress } from "../../../../components/address/address.logic";
import { createForm as createFormUser } from "../../../app/setting/user-mgt/user/user.logic";
import {
    callGender,
    callPersonType,
    callRegisterAttachment,
    callSameAddressType,
    createFieldRegisterStatus,
} from "../../../../views/account/register/register.section";
import { callStatus } from "./user-request-register.section";
import { has } from "../../../../utils/menu-context";
import router from "../../../../router";

const CIFrame = defineAsyncComponent(() => import("../../../../components/iframe/CIFrame"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userRequest";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callRepeat = ({ form }) => store.dispatch("resource/v1/security/emailToken/repeat", { data: form });
export const callMeProfile = () => store.dispatch("resource/v1/security/user/meProfile", {});
export const callRequestApprove = ({ form }) => store.dispatch(`${actionPrefix}/requestApproveRegister`, { data: form });
export const callRequestNotApprove = ({ form }) => store.dispatch(`${actionPrefix}/requestNotApproveRegister`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const whereCompanyNameIndex = where.findIndex((d) => d.name === "companyNameTh");
    if (whereCompanyNameIndex !== -1) {
        customWhere.splice(
            whereCompanyNameIndex,
            1,
            ...[
                { ...where[whereCompanyNameIndex], openBucket: true },
                { ...where[whereCompanyNameIndex], closeBucket: true, logic: "OR", name: "fullNameTh" },
            ]
        );
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then((page) => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickSave = ({ props, data, refs, formParams, otp, isSendRequest }) => {
    const { viewOnly, routerPrefix } = props;
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callRequest({ form: { userRequest: { ...data.useForm.modelRef, ...formParams }, otp, isSendRequest } })
                .finally(() => setIsLoadingApp(false))
                .then((record) => {
                    if (viewOnly) initForm({ props, data, refs });
                    else onClickView({ record, routerPrefix });
                });
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const onClickApproveRegister = ({ props, data, formParams, otp }) => {
    const { viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    data.statusKey = "approve";
    if (
        (!nextPageChecklinkIdCardPersonType2({ data }) && !["1"].includes(modelRef.refPersonType?.key)) ||
        (!nextPageChecklinkIdCardPersonType1({ data }) && ["1"].includes(modelRef.refPersonType?.key)) ||
        "wait" === data.linkIdCard
    ) {
        notification["error"]({ message: i18n.global.t("views.register.fieldIdCardNotFeign") });
        return null;
    }

    return Modal.confirm({
        title: i18n.global.t("views.register.approveRegister"),
        autoFocusButton: "cancel",
        onOk: () => {
            data.useForm.validate().then(() => {
                setIsLoadingApp(true);
                callRequestApprove({ form: { userRequest: { ...data.useForm.modelRef, ...formParams }, otp } })
                    .then((record) => {
                        if (viewOnly) {
                            router.push({
                                name: router.currentRoute.value.name,
                                params: { id: data.useForm?.modelRef?.id },
                                query: { _timestamp: new Date().getTime() },
                            });
                        } else onClickView({ record, routerPrefix });
                    })
                    .finally(() => setIsLoadingApp(false))
                    .catch((error) => {
                        validateError({ error });
                        throw error;
                    });
            });
        },
    });
};
export const onClickHardApproveRegister = ({ props, data, formParams, otp }) => {
    const { viewOnly, routerPrefix } = props;

    return Modal.confirm({
        title: i18n.global.t("views.register.approveRegister"),
        autoFocusButton: "cancel",
        onOk: () => {
            data.useForm.validate().then(() => {
                setIsLoadingApp(true);
                callRequestApprove({ form: { userRequest: { ...data.useForm.modelRef, ...formParams }, otp } })
                    .then((record) => {
                        if (viewOnly) {
                            router.push({
                                name: router.currentRoute.value.name,
                                params: { id: data.useForm?.modelRef?.id },
                                query: { _timestamp: new Date().getTime() },
                            });
                        } else onClickView({ record, routerPrefix });
                    })
                    .finally(() => setIsLoadingApp(false))
                    .catch((error) => {
                        validateError({ error });
                        throw error;
                    });
            });
        },
    });
};

export const onClickNotApproveRegister = ({ props, data, formParams, otp }) => {
    const { viewOnly, routerPrefix } = props;
    // if (!data.linkIdCard || "wait" === data.linkIdCard) {
    //     notification["error"]({ message: i18n.global.t("views.register.fieldIdCardNotFeign") });
    //     return null;
    // }
    Modal.confirm({
        title: i18n.global.t("views.register.notApproveRegister"),
        autoFocusButton: "cancel",
        onOk: () => {
            setIsLoadingApp(true);
            callRequestNotApprove({ form: { userRequest: { ...data.useForm.modelRef, ...formParams }, otp } })
            .then((record) => {
                if (viewOnly) {
                    router.push({
                        name: router.currentRoute.value.name,
                        params: { id: data.useForm?.modelRef?.id },
                        query: { _timestamp: new Date().getTime() },
                    });
                } else onClickView({ record, routerPrefix });
            })
                .finally(() => setIsLoadingApp(false))
                .catch((error) => {
                    validateError({ error });
                    throw error;
                });
        },
    });
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: [
                "**",
                "refRequestType.*",
                "refDepartment.*",
                "refStatus.*",
                "refTitle.*",
                "refAddressType.*",
                "refSameAddressType.*",
                "refRegisterRole.*",
                "refPersonType.*",
            ],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [
                {
                    name: "addresses",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "attachments",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "attachmentDocs",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "attachmentIdCards",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "attachmentSignatures",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "userCorporateCommittees",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "userRoleRequests",
                    select: ["*", "refRole.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
            ],
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [],
        };
    }
};

export const createWhereFor = ({ props }) => {
    const whereAll = [];
    const { menuContext } = props;
    const userInfo = store.state.resource.auth.info?.user;

    const whereGroup = [];

    // เห็นได้เฉพาะที่ตัวเองสร้าง
    if (has({ menuContext, key: "forSendRequest" })) {
        whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    }

    whereAll.push(...flatWhereGroup({ where: whereGroup, logic: "OR" }));
    return whereAll;
};
export const createForm = ({ props, data, refs }) => {
    return {
        ...createFormUser({ props, data, refs }),
        addresses: [createFormAddress()],
        acceptCondition: null,
        userRoleRequests: [],
        statuses: [],
    };
};

export const createRules = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refPersonType`]: [requiredWhen({ when: () => "PEOPLE" != data.registerType && "OFFICER" != data.registerType })],
        [`${prefix}refCompanyType`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}companyNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}registerCapital`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}registerDate`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}shareholdingTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}idCard`]: [
            required,
            requiredWhen({
                when: () => model.refPersonType?.key != "1",
                requiredValidator: ({ rule, value }) => {
                    return thPid.validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => model.refPersonType?.key != "1",
                requiredValidator: ({ rule, value }) => {
                    return thPidFirstCharacter.validator(rule, value);
                },
            }),
        ],
        [`${prefix}birthDate`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refNationality`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refRace`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refGender`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refTitle`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}firstNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}lastNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refEducation`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refMainOccupation`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}refSecondOccupation`]: [requiredWhen({ when: () => model.refPersonType?.key != "1" })],
        [`${prefix}positionCode`]: [requiredWhen({ when: () => model.isOfficer })],
        [`${prefix}refPosition`]: [requiredWhen({ when: () => model.isOfficer })],
        [`${prefix}refDepartment`]: [requiredWhen({ when: () => model.isOfficer })],
        [`${prefix}refSubDepartment`]: [requiredWhen({ when: () => model.isOfficer })],
        [`${prefix}refSameAddressType`]: [requiredWhen({ when: () => "PEOPLE" === data.registerType })],
        [`${prefix}mobile`]: [required],
        [`${prefix}email`]: [requiredWhen({ when: () => model.refPersonType?.key != "2" }), email],
        [`${prefix}userRoleRequests`]: [requiredWhen({ when: () => data.statusKey !== "notApprove" })],
    };
    // model?.addresses?.forEach((item, index) => {
    //     if (item.isDelete !== true && "PEOPLE" != data.registerType) {
    //         rules[`${prefix}addresses.${index}.refAddressType`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.noTh`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.soiTh`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.roadTh`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.refProvince`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.refAmphur`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.refTambon`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //         rules[`${prefix}addresses.${index}.postCode`] = [requiredWhen({ when: () => model.refRequestType?.key != "2" })];
    //     }
    // });
    model?.attachmentDocs?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentDocs.${index}`] = [requiredWhen({ when: () => model.isOfficer === true })];
            rules[`${prefix}attachmentDocs.${index}.name`] = [requiredWhen({ when: () => model.isOfficer === true })];
        }
    });
    model?.attachmentIdCards?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentIdCards.${index}`] = [
                requiredWhen({ when: () => model.refPersonType?.key === "2" || "OFFICER" === data.registerType }),
            ];
            rules[`${prefix}attachmentIdCards.${index}.name`] = [
                requiredWhen({ when: () => model.refPersonType?.key === "2" || "OFFICER" === data.registerType }),
            ];
        }
    });
    model?.attachmentSignatures?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentSignatures.${index}`] = [
                requiredWhen({ when: () => "OFFICER" === data.registerType }),
            ];
            rules[`${prefix}attachmentSignatures.${index}.name`] = [
                requiredWhen({ when: () => "OFFICER" === data.registerType }),
            ];
        }
    });
    return rules;
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id
        ? `${modelRef.refRequestType?.value} ${modelRef.refRegisterRole?.value} (${modelRef.refStatus?.value})`
        : i18n.global.t("button.create");
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = callMeProfile().then((user) => {
            const userTemp = copyForm({ form: { ...user } });
            data.userOld = user;
            return { data: [userTemp] };
        });
    }
    return promise
        .then((page) => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callPersonType({}),
        callAddressType({}),
        callGender({}),
        callRegisterAttachment({}),
        callStatus({}),
        callSameAddressType({}),
        callUserRequestType({}),
    ];
    return Promise.all(promises).then((arr) => {
        data.personTypes = arr[0];
        data.addressTypes = arr[1];
        data.genderTypes = arr[2];
        data.callRegisterAttachments = arr[3];
        data.statuses = arr[4];
        data.callSameAddressType = arr[5];
        data.userRequestTypes = arr[6];

        if ((!id && !form) || forceDefault) {
            data.registerAttachments = data.callRegisterAttachments;
            store.state.resource.auth.info?.roles.forEach((userRole) => {
                modelRef.userRoleRequests.push({ refRole: userRole.refRole });
            });
            modelRef.refRequestType = data.userRequestTypes.find((d) => d.key === "2");

            modelRef.userCorporateCommittees?.forEach((d, index) => {
                d.refRealId = data.userOld.userCorporateCommittees[index].id;
                d.model = "UserRequest";
            });
            modelRef.attachmentDocs?.forEach((d, index) => {
                d.refRealId = data.userOld.attachmentDocs[index].id;
                d.model = "UserRequest";
            });
            modelRef.attachmentIdCards?.forEach((d, index) => {
                d.refRealId = data.userOld.attachmentIdCards[index].id;
                d.model = "UserRequest";
            });
            modelRef.attachmentSignatures?.forEach((d, index) => {
                d.refRealId = data.userOld.attachmentSignatures[index].id;
                d.model = "UserRequest";
            });
            modelRef.attachments?.forEach((d, index) => {
                d.refRealId = data.userOld.attachments[index].id;
                d.model = "UserRequest";
            });
            modelRef.addresses?.forEach((d, index) => {
                d.refRealId = data.userOld.addresses[index].id;
                d.model = "UserRequest";
            });
        }

        if ("PEOPLE" === modelRef.refRegisterRole?.key) {
            modelRef.addresses[0].refAddressType = data.addressTypes?.find((d) => d.key === "1");
            modelRef.addresses[0].isValue1 = false;
            modelRef.refSameAddressType = data.callSameAddressType.find((d) => d.key === "1");
        }

        data.registerType = formRegisterType({ modelRef });
        if (!["1"].includes(modelRef.refPersonType?.key)) {
            modelRef.addresses.forEach((d) => {
                if (["1"].includes(d.refAddressType?.key)) {
                    d.isValue1 = false;
                }
            });
        }
        if ("OFFICER" != data.registerType) {
            modelRef.addresses.forEach((d) => {
                if (["2"].includes(d.refAddressType?.key)) {
                    d.isValue1 = true;
                }
            });
        }
    });
};

export const initState = ({ props, data }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [createManageSelect({ menuContext }), createManageExportCsv({ menuContext })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record, data }),
        }),
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.statusCardFields = createFieldRegisterStatus({ props, data, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => ({
            length1: data.useForm.modelRef.attachments.filter((d) => d.isDelete !== true).length,
            length2: data.useForm.modelRef.attachmentDocs.filter((d) => d.isDelete !== true).length,
            length3: data.useForm.modelRef.attachmentIdCards.filter((d) => d.isDelete !== true).length,
            length4: data.useForm.modelRef.attachmentSignatures.filter((d) => d.isDelete !== true).length,
        }),
        createRules: () => createRules({ props, data, refs }),
        itemsKey: ["attachments", "attachmentDocs", "attachmentIdCards", "attachmentSignatures"],
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs }),
                },
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const colCenter = [];
    const col2 = [];
    const { viewOnly, routerPrefix, menuContext } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel, data });
    const canRequestApprove = state.conditionAction.canRequestApprove({ props, record: initialModel });
    const canAuthenNotApprove = state.conditionAction.canAuthenNotApprove({ props, record: initialModel });
    const statusAuthen = ["waitAuthen"].includes(modelRef.refStatus?.key);
    const canAfterSave = !id || (id && isActive && canEdit);
    if (!viewOnly && id) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && canAfterSave) {
        col1.push(
            createButton({
                text: `${i18n.global.t("button.save")} `,
                classStyle: `m-1 btn-primary`,
                onClick: () => {
                    onClickSave({
                        props,
                        data,
                        refs,
                        formParams: {},
                        otp: null,
                        successText: i18n.global.t("views.request.licenseRequest.saveDraftSuccess"),
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
            })
        );
    }
    if (viewOnly && has({ menuContext, key: "canApprove" }) && "waitApprove" === modelRef.refStatus?.key && canAfterSave) {
        const statusApprove = data.statuses.find((status) => status.key === "approve");
        col2.push(
            createButton({
                text: `${i18n.global.t("button.approve")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => onClickApproveRegister({ props, data, refs }),
            })
        );
        col2.push(
            createButton({
                text: `${i18n.global.t("button.notLinkageApprove")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => onClickHardApproveRegister({ props, data, refs }),
            })
        );
    }
    if (viewOnly && has({ menuContext, key: "canApprove" }) && canAfterSave && canAuthenNotApprove) {
        const statusNotApprove = data.statuses.find((status) => status.key === "notApprove");
        col2.push(
            createButton({
                text: `${i18n.global.t("button.notApprove")}`,
                classStyle: `m-1 ${statusNotApprove?.attribute?.btnClass}`,
                onClick: () => onClickRemarkNotApprove({ props, data, refs }),
            })
        );
    }
    if (viewOnly && id && isActive && canRequestApprove) {
        col2.push(
            createButton({
                text: `${i18n.global.t("model.userRequest.sentChangeRequest")} `,
                classStyle: "m-1 btn-secondary",
                onClick: () => {
                    data.isSendRequest = true;
                    onClickOpenModalOtp({
                        props,
                        data,
                        refs,
                    });
                },
            })
        );
    }

    if (id && statusAuthen) {
        colCenter.push(
            createButton({
                text: `${i18n.global.t("model.userRequest.resendEmailConfirm")} `,
                classStyle: "m-1 btn-primary",
                onClick: () => {
                    callRepeat({ form: data.useForm.modelRef });
                },
            })
        );
    }
    return (
        <Row type="flex">
            <Col span="11">{col1}</Col>
            <Col span="1">{colCenter}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const openModalList = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/user-request-register-approve?isLayout=false&canSelect=true&cacheQuery=true`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        ),
    });
    return options;
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ["*", "refRequestType.*", "refDepartment.*", "refPersonType.*", "refStatus.*", "refTitle.*", "refRegisterRole.*", "refStatusHistoryLastApprove.*"],
            children: [
                {
                    name: "statuses",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "DESC" }],
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                },
                {
                    name: "attachments",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
                {
                    name: "userRoleRequests",
                    select: ["*", "refRole.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                },
            ],
            sort: [
                { name: "updateDate", type: "DESC" },
                { name: "refStatus.seq", type: "ASC" },
            ],
        },
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction(),
});

export const formRegisterType = ({ modelRef }) => {
    if (modelRef.isOfficer == true) {
        return "OFFICER";
    }
    const registerType = modelRef.userRoleRequests?.find((d) => {
        return "FISHERMAN" === d.refRole?.name || "PEOPLE" === d.refRole?.name;
    });
    return registerType.refRole?.name ? registerType.refRole?.name : modelRef.refRegisterRole;
};

export const waitIndexActionVisible = ({ record }) => {
    const recordType = formRegisterType({ modelRef: record });
    return record.refStatus?.key === "waitApprove" && "PEOPLE" != recordType;
};

export const onClickOpenModalOtp = ({ props, data, refs }) => {
    data.useForm
        .validate()
        .then(() => {
            openModalOtp({
                props: { dataProp: { form: { mobile: data.useForm.modelRef.mobile } } },
                onOkCallback: ({ otp, options }) => {
                    if (otp.isWaitApprove === true) {
                        otp = null;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        otp,
                        formParams: {},
                        isSendRequest: data.isSendRequest,
                    }).then(() => {
                        notification["success"]({ message: i18n.global.t("views.request.licenseRequest.requestSuccess") });
                        options.bind.onCancel();
                        options.bind.visible = false;
                    });
                },
            });
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};
export const onClickRemarkNotApprove = ({ props, data, refs }) => {
    data.statusKey = "notApprove";

    data.useForm.validate(Object.keys("")).then(() => {
        openModalNotApprove({
            onOk: (record) => {
                onClickNotApproveRegister({
                    props,
                    data,
                    refs,
                    formParams: {
                        remark: record.remark,
                    },
                })?.then(() => {
                    notification["success"]({ message: i18n.global.t("views.request.licenseRequest.requestSuccess") });
                });
            },
        });
    });
};
